import CorporateDirectory from './pages/CorporateDirectory.vue';

export default {
  'corporate-directory-employee-list': CorporateDirectory,
};
